"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Resolution = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var common_1 = require("../common");
var styles_1 = require("@material-ui/core/styles");
var useSuccessStyles = styles_1.makeStyles(function (theme) {
    var colorSuccess = theme.variables.palette.approval.colorSuccess;
    return {
        root: {
            color: colorSuccess + " !important",
            '&$checked': {
                color: colorSuccess + " !important",
            },
        },
    };
});
var useErrorStyles = styles_1.makeStyles(function (theme) {
    var colorError = theme.variables.palette.approval.colorError;
    return {
        root: {
            color: colorError + " !important",
            '&$checked': {
                color: colorError + " !important",
            },
        },
    };
});
var useSizeStyles = styles_1.makeStyles(function (theme) {
    return {
        root: {
            width: function (_a) {
                var size = _a.size;
                return size;
            },
            height: function (_a) {
                var size = _a.size;
                return size;
            },
            '& svg': {
                width: function (_a) {
                    var size = _a.size;
                    return size;
                },
                height: function (_a) {
                    var size = _a.size;
                    return size;
                },
            },
        },
    };
});
exports.Resolution = function (props) {
    var resolution = props.resolution, hasResolution = props.hasResolution, _a = props.size, size = _a === void 0 ? '' : _a, styles = props.styles;
    var successClasses = useSuccessStyles();
    var errorClasses = useErrorStyles();
    var sizeStyles = useSizeStyles({ size: size });
    var classesByResolutionType = function (resolution) {
        return resolution === common_1.ApprovalSheetResolution.APPROVE ? successClasses : errorClasses;
    };
    var resolutionClasses = hasResolution ? classesByResolutionType(resolution) : {};
    return (react_1.default.createElement(core_1.Radio, { checked: hasResolution, disabled: true, classes: resolutionClasses, className: sizeStyles.root, style: styles }));
};
